<template>
  <div v-if="map">
    <l-control-attribution
      v-if="$vuetify.breakpoint.mdAndUp"
      position="bottomleft"
      :prefix="`<a href='https://maps.gsi.go.jp/'> ${$t(
        'geographicalSurveyInstitute'
      )}</a> | <a href='https://leafletjs.com/'>Leaflet</a> | ${$t(
        'attribution'
      )}`"
    >
    </l-control-attribution>
    <l-control-attribution
      v-else
      position="topleft"
      :prefix="`<a href='https://maps.gsi.go.jp/'>${$t(
        'geographicalSurveyInstitute'
      )}</a> | <a href='https://leafletjs.com/'>Leaflet</a>`"
    ></l-control-attribution>
  </div>
</template>
<i18n>
{
  "ja": {
    "geographicalSurveyInstitute": "国土地理院",
    "attribution": "河川・流域界：国土交通省国土政策局「国土数値情報流域界・非集水域S52 河川H18～H21」をもとに(株)建設技術研究所が加工"
  },
  "en": {
    "geographicalSurveyInstitute": "Geographical Survey Institute",
    "attribution": "River and watershed delineation based on MLIT (Ministry of Land, Infrastructure, Transport and Tourism) data processed by CTI Engineering Co., Ltd."
  }
}
</i18n>
<script>
export default {
  name: "RiskmaAttributionLayer",
  computed: {
    map() {
      return this.$store.state.mapObject;
    },
  },
};
</script>

<style scoped></style>
